module.exports = __webpack_public_path__ + "img/forest-fire.9d01f028.svg";